import { useSelector } from "react-redux";

export const useAdmin = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.role === "2" || user?.role === "3" ? true : false;
};
